import About from '@scope/views/about'
import Guide from '@scope/views/guide'
import Credential from '@scope/views/credentials'
import Overview from '@scope/views/overview'
import ChannelPartnerRegister from '@scope/views/auth/ChannelPartnerRegister'
import RegisterResult from '@scope/views/auth/RegisterResult'
import Agreement from '@scope/views/auth/components/Agreement'
import PrivacyPolicy from '@scope/views/auth/components/PrivacyPolicy'
import CompanyInfo from '@scope/views/company/index'
// import Approve from '@scope/views/company/components/Approve'
import Register from '@scope/views/auth/Register'
import LoginChallenge from '@scope/views/auth/LoginChallenge'
import User from '@scope/views/user-info/index'
import GuideCreate from '@scope/views/guide/create'
import GlobalSearchResult from '@/views/global-search-result'
import Login from '@/sections/Auth/Login'
import LoginChooser from '@/sections/Auth/Login/components/LoginChooser'
import LoginMobile from '@scope/views/auth/LoginMobile'
import AdminRegister from '@/sections/Auth/AdminRegister'
import SecretVerify from '@/sections/Auth/SecretVerify'
import BindSecret from '@/sections/Auth/BindSecret'
import SetSecretQuestion from '@/sections/Auth/SetSecretQuestion'
import ResetSecretQuestion from '@/sections/Auth/ResetSecretQuestion'
import Workflow from '@System/views/workflow'
import WorkflowTechnicalSupport from '@System/views/workflow-technical-support'
import WorkflowTechnicalSupportBrowse from '@System/views/workflow-technical-support/browse'
import WorkflowSuccess from '@System/views/workflow/success'
import WorkflowError from '@System/views/workflow/error'
import AuthLayout from '@/layouts/Auth'
import Layout from '@/layouts/RouterView'
import store from '@/store'
import i18n from '@/locales'
import Account from './account'

const routes = [
  {
    name: 'Home',
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/guide',
    meta: {
      label: i18n.t('scope.text_1'),
      hidden: () => !store.getters.isAdminMode,
    },
    component: Layout,
    children: [
      {
        path: '',
        name: 'Guide',
        component: Guide,
      },
      {
        path: 'create',
        name: 'GuideCreate',
        component: GuideCreate,
      },
    ],
  },
  {
    name: 'Overview',
    path: '/overview',
    component: Overview,
  },
  { name: 'TenantCompanyInfo', path: '/tenantCompanyInfo', component: CompanyInfo },
  // { name: 'Approve', path: '/approve', component: Approve },
  { name: 'Agreement', path: '/agreement', component: Agreement, meta: { layout: 'full-screen', auth: false } },
  { name: 'PrivacyPolicy', path: '/privacy_policy', component: PrivacyPolicy, meta: { layout: 'full-screen', auth: false } },
  { name: 'UserInfo', path: '/user', component: User },
  {
    path: '/auth',
    component: AuthLayout,
    meta: { layout: 'full-screen' },
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        component: Login,
        props: { defaultLoginMode: 'mobile' },
        children: [
          {
            name: 'Auth',
            path: '',
            component: LoginChallenge,
            meta: { layout: 'full-screen', auth: false, authPage: true, transitionName: 'slide' },
          },
          {
            name: 'LoginChooser',
            path: 'chooser',
            component: LoginChooser,
            meta: { layout: 'full-screen', auth: false, authPage: true, transitionName: 'slide' },
          },
          {
            name: 'LoginChooserDefault',
            path: 'default',
            component: LoginChooser,
            meta: { layout: 'full-screen', auth: false, authPage: true, transitionName: 'slide' },
          },
          {
            name: 'LoginMobile',
            path: 'mobile',
            component: LoginMobile,
            meta: { layout: 'full-screen', auth: false, authPage: true, transitionName: 'slide' },
          },
        ],
      },
      {
        name: 'AdminRegister',
        path: 'adminregister',
        component: AdminRegister,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
      {
        name: 'SecretVerify',
        path: 'secretverify',
        component: SecretVerify,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
      {
        name: 'BindSecret',
        path: 'bindsecret',
        component: BindSecret,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
      {
        name: 'SetSecretQuestion',
        path: 'setsecretquestion',
        component: SetSecretQuestion,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
      {
        name: 'ResetSecretQuestion',
        path: 'resetsecretquestion',
        component: ResetSecretQuestion,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
      {
        name: 'RegisterResult',
        path: 'registerresult',
        component: RegisterResult,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
      {
        name: 'ChannelPartnerRegister',
        path: 'channel-partner-register',
        component: ChannelPartnerRegister,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
      {
        name: 'Register',
        path: 'register',
        component: Register,
        meta: { layout: 'full-screen', auth: false, authPage: true },
      },
    ],
  },
  {
    path: '/global-search-result',
    meta: {},
    component: Layout,
    children: [
      {
        name: 'GlobalSearchResult',
        path: '',
        component: GlobalSearchResult,
      },
    ],
  },
  {
    path: '/licenses',
    meta: {},
    component: Layout,
    children: [
      {
        name: 'Licenses',
        path: '',
        component: About,
      },
    ],
  },
  {
    path: '/credentials',
    meta: {},
    component: Layout,
    children: [
      {
        name: 'Credential',
        path: '',
        component: Credential,
      },
    ],
  },
  Account,
  {
    name: 'Workflow',
    path: '/workflow',
    component: Workflow,
  },
  {
    name: 'WorkflowTechnicalSupport',
    path: '/workflow-technical-support',
    component: Layout,
    children: [
      {
        name: 'WorkflowTechnicalSupport',
        path: '',
        component: WorkflowTechnicalSupport,
      },
      {
        name: 'WorkflowTechnicalSupportBrowse',
        path: 'browse',
        component: WorkflowTechnicalSupportBrowse,
      },
    ],
  },
  { name: 'WorkflowSuccess', path: '/workflow/success', component: WorkflowSuccess, meta: { layout: 'full-screen', auth: false } },
  { name: 'WorkflowError', path: '/workflow/error', component: WorkflowError, meta: { layout: 'full-screen', auth: false } },
]

export default routes
